var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualizacaoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18983 5.29481C1.09786 5.18688 1.01611 5.08789 0.945133 5C1.01611 4.91211 1.09786 4.81312 1.18983 4.70519C1.57157 4.2572 2.12463 3.66075 2.80908 3.06622C4.1994 1.85858 6.02663 0.75 8 0.75C9.97337 0.75 11.8006 1.85858 13.1909 3.06622C13.8754 3.66075 14.4284 4.2572 14.8102 4.70519C14.9021 4.81312 14.9839 4.91211 15.0549 5C14.9839 5.08789 14.9021 5.18688 14.8102 5.29481C14.4284 5.7428 13.8754 6.33925 13.1909 6.93378C11.8006 8.14142 9.97337 9.25 8 9.25C6.02663 9.25 4.1994 8.14142 2.80908 6.93378C2.12463 6.33925 1.57157 5.7428 1.18983 5.29481Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizacaoBlack);
export default __webpack_public_path__ + "static/media/visualizacao-black.ee94fd3d144dfc2f335ace870f242497.svg";
export { ForwardRef as ReactComponent };